/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/



import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import * as _ from 'lodash';
import { DataStoreService } from '../../../../../src/app/core/services/datastore.service';
import { TerminalStatus } from '../../../core/model/terminal-status.model';
import { TrainData } from '../../../core/model/train-data.model';
import { AppUtilityService } from '../../../core/services/app-utility.service';
import { LmsLoaderService } from '../../../core/services/lms-loader.service';
import { UserService } from '../../../core/services/user.service';
import { LocoDetail } from './../../../core/model/loco-detail.model';
import { Tab } from './../../../core/model/tab.model';
import { TerminalSummary } from './../../../core/model/terminal-summary.model';
import { LmsModuleService } from './../../../core/services/lms-module.service';
import { LmsTabsDragDropService } from './../../../core/services/lms-tabs-drag-drop.service';
import { LmsTerminalStatusSubmenuService } from './../../../core/services/lms-terminal-status-submenu.service';
import { StaticDataStoreService } from './../../../core/services/static-datastore.service';
import { TerminalConfigService } from './../../shared/services/terminal-config.service';
import { TerminalStatusService } from './../../shared/services/terminal-status.service';




/**
 * @export
 * @class LmsTerminalBoundStatusComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-terminal-bound-status',
  templateUrl: './lms-terminal-bound-status.component.html',
  styleUrls: ['./lms-terminal-bound-status.component.scss']
})
export class LmsTerminalBoundStatusComponent implements OnInit, OnDestroy {
  startPaging = false;
  MathFunction = Math;
  @Input() status: Array<LocoDetail>;
  @Input() tab: Tab;
  @Input() allData: TerminalStatus;
  @Input() statusHeader: string;
  @Input() isDroppable: Boolean = true;
  @Input() numOfVisible: number;
  @Input() actualNoOfVisible: number;
  @Input() firstVisible: number;
  @Input() onTermEachSlideHeight: number;
  @Output() onLocoSelect: EventEmitter<LocoDetail> = new EventEmitter<LocoDetail>();
  @Output() hideContextMenu: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() updateLocos: EventEmitter<any> = new EventEmitter<any>();
  @Output() heightCalculate: EventEmitter<boolean> = new EventEmitter<boolean>();

  private active;
  private selectedTrainLocos: Object = {
    trains: { list: [], identifier: [] },
    locos: { list: [], identifier: [] }
  };
  showStatusList;

  startPage;

  endPage;

  statusCarousel;

  subscription: any;

  displayHeaderNames;

  terminalSummary?: TerminalSummary;

  yardLocalStationSummary?: any; 

  constructor(private lmsTerminalStatusSubmenuService: LmsTerminalStatusSubmenuService,
    private terminalConfigService: TerminalConfigService,
    private lmsModuleService: LmsModuleService,
    private lmsTabsDragDropService: LmsTabsDragDropService,
    private staticDataStoreService: StaticDataStoreService,
    private changeDetectorRef: ChangeDetectorRef,
    private lmsLoaderService: LmsLoaderService,
    private terminalStatusService: TerminalStatusService,
    private appUtilService: AppUtilityService,
    private dataStoreService: DataStoreService, 
    public user: UserService) {
    this.statusCarousel = terminalConfigService.terminalConfigData.footer.carousel;
    this.displayHeaderNames = this.lmsTerminalStatusSubmenuService.terminalStatusMapping;
   
  }

  /**
   * This is used to subscribe Terminal status menu
   * @memberOf LmsTerminalStatusComponent
   */
  ngOnInit() {
    this.subscription = this.lmsTerminalStatusSubmenuService.terminalStatusMenu.subscribe((data) => {
      this.showStatusList = data;
      this.checkStatusisActive(data);
    });
    if (this.allData && this.allData.terminalStatusLocos && this.allData.terminalStatusLocos.terminalSummary) {
      this.terminalSummary = this.allData.terminalStatusLocos.terminalSummary;
    }
    if (this.allData && this.allData.terminalStatusLocos && this.allData.terminalStatusLocos.yardLocalStationSummary) {
      this.yardLocalStationSummary = this.allData.terminalStatusLocos.yardLocalStationSummary;
    } 
  }

  /**
   * It checks whether status is active or not
   * @param {any} data
   * @memberOf LmsTerminalStatusComponent
   */
  checkStatusisActive(data) {
    setTimeout(() => {
      if (data[this.findWithAttr(data, 'value', this.statusHeader)] !== undefined ) {
        this.active = data[this.findWithAttr(data, 'value', this.statusHeader)].active;
      }
    }, 100);
  }

  /**
   * THis method is used to find attr from Array
   * @param {any} array
   * @param {any} attr
   * @param {any} value
   * @returns
   * @memberOf LmsTerminalStatusComponent
   */
  findWithAttr(array, attr, value) {
    for (let i = 0; i < array.length; i += 1) {
      if (array[i][attr] === value) {
        return i;
      }
    }
    return -1;
  }

  /**
   * Shows LocoMotive Context menu
   * @param {LocoDetail} loco
   * @memberOf LmsTerminalStatusComponent
   */
  public showLocoContextMenu($event) {
    this.onLocoSelect.emit($event);
  }

  /** ng life cycle method it calls when we goes
   *  from this component to another component
   */
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  /**
   * Sets Status Bond
   * @param {LocoDetail} status
   * @param {string} headerName
   * @memberOf LmsTerminalStatusComponent
   */
  setStatusBound(status: LocoDetail, headerName: string, originalHeaderName?: string) {
    this.tab.openState = {
      status: status,
      headerName: headerName,
      activeStatus: true,
      collpase: false,
      singleClick: undefined
    };
    if (originalHeaderName) {
      this.terminalStatusService.expandHeaderName = originalHeaderName;
    }
    const tabData = {
      id: this.tab.id,
      subType: this.tab.subType,
      data: {}
    };
    tabData.data[this.tab.subType] = this.allData;
    this.dataStoreService.putValue(this.tab, tabData);
    //this.lmsModuleService.updateSelectedTab(this.tab);
    setTimeout(() => {
      this.lmsTabsDragDropService.updateInteractiveLocoTrains();
    }, 100);

    this.heightCalculate.emit(true);
  }
  /**
   * when we click on terminal then what
   * we need to do is handle on this method
   * @memberof LmsTerminalBoundStatusComponent
   */
  onTerminalClick() {
    if (this.resetAllClickOnTrainLocos(false, false, false, false).locoCounter) {
      this.lmsTabsDragDropService.updateDropEndValue('end', {
        dragElement: {
          type: 'INBOUND',
          train: null,
          loco: 'last'
        },
        dropElement: {
          type: 'onTerminalList',
          train: {},
          loco: 'last'
        },
        trainLocos: undefined
      }
      );
    }
  }

  /**
    * do some setting on loco click action like
    *  clicked property set true or vice versa
    * @param {LocoDetail} loco
    * @param {any} event
    * @returns
    * @memberof LmsTerminalBoundComponent
    */
  onLocoClick(eventObj) {
    const loco = eventObj.data;
    const event = eventObj.event;
    event.stopPropagation();
    this.hideContextMenu.emit(true);
    if (loco.inPendingList || loco.locomotiveIdentifier.toLowerCase() === 'zzzzzzzzzzzzzz' || loco.locomotiveIdentifier.trim() === '') {
      return false;
    }

    loco.clicked = !loco.clicked;
    if (loco.clicked) {
      if (this.resetAllClickOnTrainLocos(false, false, false, false).trainCounter === 1) {
        loco.order = ++this.resetAllClickOnTrainLocos(false, false, false, false).locoCounter;
      } else {
        loco.order = ++this.resetAllClickOnTrainLocos(true, false, false, false).locoCounter;
      }
    } else {
      loco.order = 0;
    }

    this.lmsTabsDragDropService.updateInteractiveLocoTrains(loco, loco.clicked ? true : false);
  }
  /**
   * work on dragover
   * @param {any} e
   * @returns
   * @memberof LmsTerminalBoundStatusComponent
   */
  dragover(e) {
    return false;
  }

  /**
   * @param {any} e
   * @param {any} dropId
   * @returns
   *
   * @memberOf LmsTabsComponent
   */
  drop(e) {
    return false;
  }

  /**
   * reset train or loco status
   *  as per pass parameter
   * @private
   * @param {Boolean} setTrainStatus
   * @param {Boolean} trainStatus
   * @param {Boolean} setLocoStatus
   * @param {Boolean} locoStatus
   * @returns
   * @memberof LmsTerminalBoundComponent
   */
  private resetAllClickOnTrainLocos(setTrainStatus: Boolean, trainStatus: Boolean, setLocoStatus: Boolean, locoStatus: Boolean) {
    const inBoundTrains = this.allData.terminalStatusIO.inBoundTrains;
    const outBoundTrains = this.allData.terminalStatusIO.outBoundTrains;
    const terminalList = this.allData.terminalStatusLocos;
    const totalTerminalListLocos = [terminalList.onTerminalList,
    terminalList.atServiceCentreList,
    terminalList.onPitList,
    terminalList.inShopList,
    terminalList.inReadyTrackList,
    terminalList.storedAtTerminalList,
    terminalList.yardAndLocalList
    ];



    const inBoundTrainsLength = inBoundTrains.length;
    const outBoundTrainsLength = outBoundTrains.length;
    let trainCounter = 0;
    let locoCounter = 0;
    // for inBoundTrains
    for (let i = 0; i < inBoundTrainsLength; i++) {
      if (setTrainStatus) {
        this.setTrainClickedStatus(inBoundTrains[i], trainStatus, locoStatus);
      } else {
        const inBoundMaxOrder = this.getTrainCounter(inBoundTrains[i]);
        trainCounter = inBoundMaxOrder > trainCounter ? inBoundMaxOrder : trainCounter;
      }

      const locos = inBoundTrains[i].locoDetails;
      if (setLocoStatus) {
        this.setTrainLocosClickedStatus(locos, locoStatus);
      } else {
        const inLocoMaxOrder = this.getLocoCounter(locos);
        locoCounter = inLocoMaxOrder > locoCounter ? inLocoMaxOrder : locoCounter;
      }

    }

    // for outboundTrains
    for (let i = 0; i < outBoundTrainsLength; i++) {
      if (setTrainStatus) {
        this.setTrainClickedStatus(outBoundTrains[i], trainStatus, locoStatus);
      } else {
        const outBoundMaxOrder = this.getTrainCounter(outBoundTrains[i]);
        trainCounter = outBoundMaxOrder > trainCounter ? outBoundMaxOrder : trainCounter;
      }

      const locos = outBoundTrains[i].locoDetails;
      if (setLocoStatus) {
        this.setTrainLocosClickedStatus(locos, locoStatus);
      } else {
        const outLocoMaxOrder = this.getLocoCounter(locos);
        locoCounter = outLocoMaxOrder > locoCounter ? outLocoMaxOrder : locoCounter;
      }
    }

    if (setLocoStatus) {
      // in terminal List only Locos Exist
      for (let k = 0; k < totalTerminalListLocos.length; k++) {
        if (!_.isEmpty(totalTerminalListLocos[k])) {
          this.setTrainLocosClickedStatus(totalTerminalListLocos[k], locoStatus);
        }
      }

    } else {
      for (let k = 0; k < totalTerminalListLocos.length; k++) {
        if (!_.isEmpty(totalTerminalListLocos[k])) {
          const terminalListMaxOrder = this.getLocoCounter(totalTerminalListLocos[k]);
          locoCounter = terminalListMaxOrder > locoCounter ? terminalListMaxOrder : locoCounter;
        }
      }
    }

    return { trainCounter: trainCounter, locoCounter: locoCounter };
  }

  /**
   * how many loco are clicked
   * get by this method
   * @private
   * @param {Array<LocoDetail>} locos
   * @returns
   * @memberof LmsTerminalBoundStatusComponent
   */
  private getLocoCounter(locos: Array<LocoDetail>) {
    let locoCount = 0;
    const locosLength = locos && locos.length ? locos.length : 0;
    for (let k = 0; k < locosLength; k++) {
      if (!locos[k].inPendingList) {
        locoCount = locos[k].order > locoCount ? locos[k].order : locoCount;
      }
    }
    return locoCount;
  }

  /**
   *  how many trains are clicked
   * get their counter
   * @private
   * @param {TrainData} train
   * @returns
   * @memberof LmsTerminalBoundStatusComponent
   */
  private getTrainCounter(train: TrainData) {
    return !train.inPendingList ? train.order : 0;
  }

  /**
   * in this method we set train status
   * true or false as per pass parameter
   * @private
   * @param {TrainData} train
   * @param {Boolean} trainStatus
   * @param {Boolean} locoStatus
   * @memberof LmsTerminalBoundStatusComponent
   */
  private setTrainClickedStatus(train: TrainData, trainStatus: Boolean, locoStatus: Boolean) {
    train.clicked = trainStatus;
    train.order = 0;
  }

  /**
     * set train respective loco click status
     * @private
     * @param {Array<LocoDetail>} locos
     * @param {Boolean} status
     * @memberof LmsTerminalBoundComponent
     */
  private setTrainLocosClickedStatus(locos: Array<LocoDetail>, status: Boolean) {
    const locosLength = locos.length;
    for (let k = 0; k < locosLength; k++) {
      locos[k].clicked = status;
      locos[k].order = 0;

    }
  }

  /**
   * when page is change then set header
   * @param {any} event
   * @memberof LmsTerminalBoundStatusComponent
   */
  onPageChange(event) {
    if (event.page || (event.page === 0 && this.startPaging)) {
      this.updateLocos.emit({ 'statusHeader': this.statusHeader, page: event.page });
      this.startPaging = true;
    }
  }
}
